kv.controller('legalCaseListCtrl', function ($scope, $element, $attrs, $http, resource, $filter, $uibModal, $rootScope, $injector) {
	var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
	vm.primaryKey = 'legal_case_id';
	vm.entity = 'legal_case';

	vm.count = {
		total: 0,
		showing: 0
	};

	vm.getInfinitScroll({
		search: {
			is_active: "1",
			case_status_id: 2,
			case_status_name: 'IN_PROGRESS',
		},
		params: {
			action: 'legal_case'
		},
		url: "legal_case",
		callback: function (response) {
			vm.countLines = 0;
			if (!response.data) return;
			vm.countLines = (response.data ? response.total : 0);
		}
	});

	vm.edit = function (entity) {
		vm.openModal({
			templateUrl: "legal_case-list.ctrl",
			controller: "",
			controllerAs: 'vm',
			size: 'lg',
			resolve: {
				data: function () {
					return {
						index: $index,
						entity: entity
					};
				}
			}
		}).then((result) => {
			if (result.index == -1) {
				return this.infinitScroll.items.push(result.entity);
			} else return Object.assign(entity, result.entity);
		});
	};

	vm.checkPortalJustStatus = function () {
		var REST = resource.init('status/portal-just');

		REST.get({
			params: {
				fresh: new Date()
			}
		}).then(function (response) {
			// response contains: time, status, color, message, response, error, checked_at
			if (response.status === 'error') {
				console.error('Portal Just request failed:', response.error);
			}

			vm.portalJustStatusMessage = response.message;
			vm.portalJustStatusColor = response.color;
			vm.portalJustStatusUpdatedAt = response.updated_at;
			vm.portalJustResponseTime = response.time + 's';

		//	vm.portalJustRawResponse = response.response;
		}).catch(function (err) {
			console.error('Error fetching portal status:', err);
			vm.portalJustStatusMessage = 'Error';
			vm.portalJustStatusColor = '#fa5775'; // red
		});
	};

// You can call it automatically on page load:
	vm.checkPortalJustStatus();

	vm.getResponsiblesNames = function(entity) {
		return entity.responsibles.map(function(responsible) { return responsible.full_name; }).join(', ');
	};

	vm.addEditLegalCaseConfigurationSettings = function (){
		vm.openModal({
			templateUrl: "legal-case-configuration-settings",
			controller: 'legalCaseConfigurationSettingsCtrl',
			controllerAs: 'vm',
			size: 'lg',
			resolve: {
				params: {
					//  entity: entity
				}
			}
		}).then(response => {
			window.location = "/legal_case/";
		});
	};

	vm.moveEntities = function (type_id) {
		const filteredSearch = Object.fromEntries(
			Object.entries(vm.infinitScroll.search).filter(([key, value]) => value !== null)
		);
		vm.openModal({
			templateUrl: 'legal-case-list-move',
			controller: LegalCaseListMoveCtrl,
			size: 'md',
			resolve: {
				data: function () {
					return {
						searchList: filteredSearch,
						countLines: vm.countLines,
						type: type_id
					};
				},
			},
			backdrop: 'static',
			keyboard: false
		}).then(response => {
			if (response == "ok") vm.infinitScroll.search.refresh++;
		});
	};

	return vm;
});

